import CommonService from './common.service'
import { httpParams } from 'utils/interfaces'

class UserService extends CommonService {
  async getMe() {
    return await this.get('/me')
  }

  async userProfile(params: httpParams) {
    return await this.put('/profile', params)
  }
}

export const userService = new UserService()
